/**
 * Redação do log ao vivo (spec 2026-09-24-robo-painel-de-ajustes, 4.1).
 *
 * O firmware já não ecoa token nem senha (`DirectConsole.h`: "Never echo request
 * bytes, passwords or tokens"). A tela filtra de novo porque o log é copiável e
 * vai parar em chamado, e uma versão futura do firmware pode esquecer a regra.
 * A linha inteira some: cortar só o pedaço deixaria o resto do segredo à mostra
 * quando o formato mudar.
 */
const SENSIVEL = [/Bearer /i, /token/i, /senha/i, /password/i, /CONFIG /]

export const LINHA_OMITIDA = '[linha omitida]'

export function redigir(linha: string): string {
  return SENSIVEL.some((r) => r.test(linha)) ? LINHA_OMITIDA : linha
}

/** No máximo 2.000 linhas, só na memória da aba: nada vai para o servidor. */
export const TETO_DO_LOG = 2000

export type LinhaDoLog = { em: number; texto: string }

/**
 * O buffer guarda a linha JÁ redigida: o que está na memória é o que a tela
 * mostra e o que "Copiar" copia, e não há caminho para a linha crua sair dali.
 */
export class BufferDeLog {
  private linhas: LinhaDoLog[] = []

  constructor(private readonly teto: number = TETO_DO_LOG) {}

  acrescentar(linha: string, em: number = Date.now()): void {
    this.linhas.push({ em, texto: redigir(linha) })
    if (this.linhas.length > this.teto) this.linhas.splice(0, this.linhas.length - this.teto)
  }

  todas(): readonly LinhaDoLog[] {
    return this.linhas
  }

  get tamanho(): number {
    return this.linhas.length
  }

  /** O texto de "Copiar": uma linha por linha, na ordem em que chegaram. */
  texto(): string {
    return this.linhas.map((l) => l.texto).join('\n')
  }

  limpar(): void {
    this.linhas = []
  }
}
